import { HttpUtilService, HttpClient } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import { cxoneSdkState } from '../state';

export async function resolveTeamId(
  baseUrl: string,
  reqInit: ReturnType<HttpUtilService['initHeader']>
): Promise<number | undefined> {
  let teamId = cxoneSdkState.storedUserInfo?.teamId;

  if (!teamId) {
    const agentId = cxoneSdkState.storedUserInfo?.icAgentId;
    if (agentId) {
      try {
        logger.debug('[CXone SDK] No teamId, fetching agent details for agentId:', agentId);
        const agentUrl = `${baseUrl}/InContactAPI/services/v23.0/agents/${agentId}`;
        const agentResponse = await HttpClient.get(agentUrl, reqInit);
        logger.debug('[CXone SDK] Agent details response:', agentResponse);

        const agentData = agentResponse?.data || agentResponse;
        if (agentData && typeof agentData === 'object') {
          const dataObj = agentData as Record<string, unknown>;
          const agents = dataObj.agents as Array<Record<string, unknown>> | undefined;
          const agent = agents?.[0] || dataObj;
          teamId = agent.teamId as number | undefined;
          logger.debug('[CXone SDK] Got teamId from agent details:', teamId);
        }
      } catch (agentError) {
        logger.warn('[CXone SDK] Failed to fetch agent details:', agentError);
      }
    }
  }

  if (!teamId) {
    try {
      logger.debug('[CXone SDK] No teamId, fetching teams list...');
      const teamsUrl = `${baseUrl}/InContactAPI/services/v23.0/teams`;
      const teamsResponse = await HttpClient.get(teamsUrl, reqInit);
      logger.debug('[CXone SDK] Teams response:', teamsResponse);

      const teamsData = teamsResponse?.data || teamsResponse;
      if (teamsData && typeof teamsData === 'object') {
        const teams = (teamsData as Record<string, unknown>).teams as
          | Array<{ teamId: number }>
          | undefined;
        if (teams && teams.length > 0) {
          teamId = teams[0].teamId;
          logger.debug('[CXone SDK] Got teamId from teams list:', teamId);
        }
      }
    } catch (teamsError) {
      logger.warn('[CXone SDK] Failed to fetch teams:', teamsError);
    }
  }

  return teamId;
}
